import { render } from "./DoughnutChartScore.vue?vue&type=template&id=24de662a&scoped=true"
import script from "./DoughnutChartScore.vue?vue&type=script&lang=js"
export * from "./DoughnutChartScore.vue?vue&type=script&lang=js"

import "./DoughnutChartScore.vue?vue&type=style&index=0&id=24de662a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24de662a"]])

export default __exports__